// extracted by mini-css-extract-plugin
module.exports = {"books":"BooksResultsd5d8bbaf295bdfa65c04a0a32769e634"};